import React, { useContext } from 'react';
import './footer.scss';
import getFooterLinks from './getFooterLinks';
import { StaticContext } from '../../StaticContext';

const Footer = () => {
  const {
    environment: { languageCode },
  } = useContext(StaticContext);
  return (
    <footer className="sm-captive-footer wds-container wds-flex">
      <div className="wds-p-2 wds-m-3">
        {getFooterLinks(languageCode).map(linkData => (
          <a
            key={linkData.href}
            className="sm-captive-footer__link"
            href={linkData.href}
            rel="noopener noreferrer"
          >
            {linkData.text}
          </a>
        ))}
        {/* Onetrust pipes in the text content here */}
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a
          href="#cookiePreferences"
          className="ot-sdk-show-settings"
          data-testid="CaptiveFooterLinks__cookiePreferences"
        />
      </div>
    </footer>
  );
};
export default Footer;
